<template>
  <div class="process-box">
    <div class="content">
      <div class="process-title-box">
            <div class="process-title">我们的服务</div>
            <div class="process-title">本能且与众不同</div>
          </div>
        <div class="steps" >
          <div @click="toHref(index)" v-for="(step, index) in stepList" :key="index" class="step-item" @mouseleave="hoverIndex = null"  @mousemove="hover(index)" >
            <div class="icon"><img src="@/assets/home/add.png" alt=""></div>
            <div class="step-number" :style="hoverIndex == index?'opacity: 1;':''" >{{ `0${index + 1}` }}</div>
            <div class="step-title" v-for="title in step.title" :style="hoverIndex == index?'color: #FFCFA0;':''">{{ title }}</div>
            <div class="step-more" :style="hoverIndex == index?'opacity: 1;':''">MORE</div>
            <div class="step-description">
              <div class="mark-div" :style="hoverIndex == index?'display:none;':''"></div>
              <img :src="step.img" class="hvr-grow" alt=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stepList: [
        {
          title: ["品牌", "设计"],
          img: require("@/assets/home/img1.png"),
        },
        {
          title: ["系统", "开发"],
          img: require("@/assets/home/img2.png"),
        },
        {
          title: ["高端网站", "定制开发"],
          img: require("@/assets/home/img3.png"),
        },
        {
          title: ["微信", "平台开发"],
          img: require("@/assets/home/img4.png"),
        },
        {
          title: ["APP", "开发"],
          img: require("@/assets/home/img5.png"),
        },
      ],
      hoverIndex: null,
    };
  },
  methods: {
    hover(index) {
      this.hoverIndex = index;
    },
    toHref(index) {
      console.log("toHref", index);
      this.$router.push({
        name: "business",
        query: {
          type: index,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import url("./index.scss");
</style>
